import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { db, app, auth } from "./firebase.js";
import { collection, doc, setDoc } from "firebase/firestore";

/**
 * Requests notification permission and stores FCM token under
 * users/{uid}/fcmTokens/{token}. Call once after login.
 */
export const initMessaging = async () => {
  try {
    const messaging = getMessaging(app);
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    // VAPID key is taken from Firebase console → Cloud Messaging tab
    const vapidKey = process.env.REACT_APP_VAPID_KEY;
    const token = await getToken(messaging, { vapidKey });
    if (!token) return;

    const uid = auth.currentUser.uid;
    await setDoc(
      doc(collection(db, "users", uid, "fcmTokens"), token),
      { createdAt: new Date(), platform: navigator.userAgent },
      { merge: true }
    );

    // foreground handler
    onMessage(messaging, (payload) => {
      console.log("🔔 Push message in foreground:", payload);
    });
  } catch (err) {
    console.error("FCM error:", err);
  }
};
